import { marked } from "marked";

// Konfiguracja marked dla bezpiecznego renderowania
marked.setOptions({
	breaks: true,
	sanitize: true,
	sanitizer: function (text) {
		return text.replace(/[&<>"']/g, function (m) {
			const map = {
				"&": "&amp;",
				"<": "&lt;",
				">": "&gt;",
				'"': "&quot;",
				"'": "&#039;",
			};
			return map[m];
		});
	},
});

export const parseMarkdown = (text) => {
	return marked.parse(text);
};
